module.exports = __webpack_public_path__ + "static/img/codeTraceability1.d051699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/codeTraceability1.jpg
// module id = kewa
// module chunks = 0